export default __webpack_public_path__ + "new-tab.2a74fb6a2506940c.svg";